<template>
	<b-modal ref="modal" title="Edit donation event" :busy="loading>0">
		<div v-if="curUserGiftType">
			<form action="" @submit.stop.prevent="save(); return false;" id="userGiftTypeEditForm">
				<b-form-row>
					<b-col>
						<b-form-group label="Service">
							<b-avatar v-if="curUserGiftType.service_icon && curUserGiftType.service_icon.url" :src="curUserGiftType.service_icon.url" size="1.2rem" :title="curUserGiftType.service_name"/>
							{{curUserGiftType.service_name}}
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group label="Gift type">
							<b-img v-if="curUserGiftType.image && curUserGiftType.image.url" :src="curUserGiftType.image.url" style="max-width: 2rem; max-height: 1.2rem" :title="curUserGiftType.name"/>
							{{curUserGiftType.name}}
						</b-form-group>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col>
						<b-form-group label="Singular label">
							<b-form-input v-model="curUserGiftType.string"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group label="Plural label" description="Use # for the number">
							<b-form-input v-model="curUserGiftType.string_multi"></b-form-input>
						</b-form-group>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col>
						<b-form-group label="Sounds">
							<pipi-pupu-multi-file v-model="curUserGiftType.sounds" accept="audio/*"></pipi-pupu-multi-file>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group label="Images">
							<pipi-pupu-multi-file v-model="curUserGiftType.images" accept="image/*"></pipi-pupu-multi-file>
						</b-form-group>
					</b-col>
				</b-form-row>
				<b-form-checkbox v-model="curUserGiftType.group">Group multiple similar donations into one</b-form-checkbox>
			</form>
		</div>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<template #modal-footer="{cancel}">
			<b-spinner v-show="loading>0" small label="Loading"></b-spinner>
			<b-button size="sm" variant="success" type="submit" form="userGiftTypeEditForm">
				Save
			</b-button>
			<b-button size="sm" @click="cancel()">
				Cancel
			</b-button>
		</template>
	</b-modal>
</template>

<script>
import PipiPupuMultiFile from '@/components/PipiPupuMultiFile.vue';

export default {
	data() { return {
		loading: 0,
		error: null,
		curUserGiftType: null,
	}},
	components: {
		PipiPupuMultiFile,
	},
	mounted() {
	},
	methods: {
		show(service_id, type) {
			this.curUserGiftType = null;
			this.loading++;
			this.$api.get(`userGiftType/${service_id}/${type}`).then(giftType => {
				this.curUserGiftType = giftType;
			}).catch(err => this.error = err).finally(() => this.loading--);
			this.$refs.modal.show();
		},
		save() {
			this.loading++;
			this.error = null;
			this.$api.post(`userGiftType/${this.curUserGiftType.service_id}/${this.curUserGiftType.gift_type}`, {
				string: this.curUserGiftType.string||null,
				string_multi: this.curUserGiftType.string_multi||null,
				sounds: this.curUserGiftType.sounds.map(s => s.md5),
				images: this.curUserGiftType.images.map(s => s.md5),
				group: this.curUserGiftType.group,
			}).then(() => {
				this.$refs.modal.hide();
				console.log('saveddddd');
				this.$emit('saved');
			}).finally(() => this.loading--);
		},
	},
};
</script>
